import { configureStore } from "@reduxjs/toolkit"
import confReducer from "./features/confSlice"
import auxReducer from "./features/auxSlice"
import authReducer from "./features/authSlice"
import postReducer from "./features/postSlice"
import transactionReducer from "./features/transactionSlice"
import userReducer from "./features/userSlice"
import sessionReducer from "./features/sessionSlice"
import thunk from "redux-thunk"

export const store = configureStore({
  reducer: {
    aux: auxReducer,
    conf: confReducer,
    auth: authReducer,
    post: postReducer,
    transaction: transactionReducer,
    user: userReducer,
    session: sessionReducer,
  },
  middleware: [thunk],
})
